import { defineStore } from 'pinia';
import { ref } from 'vue';
// import useErrorStore from '@/stores/error';
// import type { ErrorStateObj } from '@/types/error';
import { postAutoLoginApi, postSecureLoginApi } from '../services/adminLoginService';
import { setCookieForDay } from '@common/common/utils';
import Cookies from 'js-cookie';

const useAdminLoginStore = defineStore('adminLogin', () => {
    // const errorStore = useErrorStore();
    const accessToken = ref<string | null>(null);
    const autoLoginTried = ref<boolean>(false);

    const getSecureToken = async (LoginID: string, LoginPW: string) => {
        try {
            const resp = await postSecureLoginApi(LoginID, LoginPW);
            if (resp.IsSuccess) {
                accessToken.value = resp.Data.AccessToken;
                setCookieForDay('tokenValue', resp.Data.AccessToken);
                return resp;
            }
        } catch (error) {
            console.error('Error fetching secure token:', error);
        }
    };

    const getAutoToken = async () => {
        if (autoLoginTried.value) return { AccessToken: accessToken.value }; // 이미 시도했으면 재요청 안함
        autoLoginTried.value = true;

        try {
            const response = await postAutoLoginApi();
            if (response.IsSuccess) {
                accessToken.value = response.Data.AccessToken;
                setCookieForDay('tokenValue', response.Data.AccessToken);
                return response.Data;
            }
        } catch (error) {
            clearToken();
            throw error;
        }
    };

    const clearToken = () => {
        accessToken.value = null;
        Cookies.remove('tokenValue');
        // 토큰 초기화 후 새로고침
        // window.location.reload();
    };

    return {
        getSecureToken,
        getAutoToken,
        accessToken,
        autoLoginTried,
        clearToken,
    };
});

export default useAdminLoginStore;
